import Image from 'next/image';

export const MonoTone = ({ collection }: { collection: any }) => {
  return (
    <div>
      <div className="flex items-center justify-center gap-x-4">
        {collection.header_image && (
          <Image
            src={`${collection.header_image}`}
            alt={collection.title}
            unoptimized
            fill
            className="!relative !h-[40px] !w-auto"
          />
        )}
        <h1 className="font-header text-3xl font-bold">{collection.title}</h1>
      </div>
      {collection.description && (
        <div
          className="mx-auto mt-2 max-w-5xl text-center"
          dangerouslySetInnerHTML={{ __html: collection.description }}
        />
      )}
    </div>
  );
};
